export const sygnet = ['160 160', `
  <title>Microbiome edge</title>
  <g>
  </g>
`]
